var _path, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddStudentInTeacher(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_27)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_27",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 0H0V44H44V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43 22C43 10.402 33.598 1 22 1C10.402 1 1 10.402 1 22C1 33.598 10.402 43 22 43C33.598 43 43 33.598 43 22Z",
    fill: "#8452EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 22C43 10.402 33.598 1 22 1C10.402 1 1 10.402 1 22C1 33.598 10.402 43 22 43C33.598 43 43 33.598 43 22Z",
    stroke: "white",
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 12.375C21.7216 12.375 21.4466 12.4352 21.1853 12.5512L11.5431 16.9039C11.2166 17.0543 11 17.441 11 17.875C11 18.309 11.2166 18.6957 11.5431 18.8461L13.5334 19.7441C12.9697 20.8527 12.65 22.1633 12.65 23.5426V24.75C12.65 25.9703 12.2788 27.2293 11.8834 28.2219C11.66 28.7805 11.4056 29.3305 11.11 29.8375C11 30.0223 10.9691 30.2629 11.0309 30.482C11.0928 30.7012 11.2372 30.8645 11.4159 30.9203L13.6159 31.6078C13.7603 31.6551 13.915 31.6207 14.0422 31.5219C14.1694 31.423 14.2588 31.2598 14.2863 31.075C14.5819 29.2359 14.4341 27.5859 14.2141 26.4043C14.1041 25.7941 13.9563 25.1711 13.75 24.5996V23.5426C13.75 22.2449 14.1006 21.0203 14.7091 20.0406C15.1525 19.3746 15.7266 18.8375 16.4003 18.5066L21.7972 15.8555C22.0791 15.718 22.3988 15.8898 22.5088 16.2422C22.6188 16.5945 22.4813 16.9941 22.1994 17.1316L16.8025 19.7828C16.3763 19.9934 16.0016 20.3156 15.6956 20.7109L21.1819 23.1859C21.4431 23.302 21.7181 23.3621 21.9966 23.3621C22.275 23.3621 22.55 23.302 22.8113 23.1859L32.4569 18.8461C32.7834 18.7 33 18.309 33 17.875C33 17.441 32.7834 17.0543 32.4569 16.9039L22.8147 12.5512C22.5534 12.4352 22.2784 12.375 22 12.375ZM15.4 28.5312C15.4 30.048 18.3563 31.625 22 31.625C25.6438 31.625 28.6 30.048 28.6 28.5312L28.0741 22.2836L23.1859 24.4922C22.8044 24.6641 22.4022 24.75 22 24.75C21.5978 24.75 21.1922 24.6641 20.8141 24.4922L15.9259 22.2836L15.4 28.5312Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddStudentInTeacher);
export default __webpack_public_path__ + "static/media/add-student-in-teacher.0a9b1351d652da765b374489f6820646.svg";
export { ForwardRef as ReactComponent };